import React from "react";
import { shallow } from "zustand/shallow";
import {
  Button,
  Text,
  Title,
  Stack,
  ThemeIcon,
  UnstyledButton,
  Box,
  Flex,
} from "@mantine/core";
import { IconCheck, IconCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import RideChallengeHeader from "./RideChallengeHeader";
import useAppStore from "@components/Microsite/microsite-store";
import sendActionEvents, {
  actionIds,
} from "@components/EntityActionAssociator/sendActionEvents";

export default function PresentAtLocationInstructions() {
  const { t } = useTranslation();
  const { setActiveStep, entityInfo } = useAppStore(
    (state) => ({
      setActiveStep: state.setActiveStep,
      entityInfo: state.entityInfo,
    }),
    shallow
  );

  return (
    <div>
      <RideChallengeHeader />
      <Stack mt="xl" gap="md">
        <Title order={3} align="center" c="white">
          <ThemeIcon radius="xl" size="sm" color="green" mr="2px">
            <IconCheck strokeWidth={5} size={16} />
          </ThemeIcon>{" "}
          {t("microsite:youre_registred_for_the")}
          <br />
          2026 Let's Ride Challenge
        </Title>
        <Text align="center" c="dimmed">
          {t("microsite:to_start_competing")}
        </Text>
      </Stack>
      <Stack mt="lg" gap="md">
        <Text align="center" fw={600} c="white" size="xl">
          {t("microsite:are_you_at_a_dealership_right_now")}
        </Text>
        <UnstyledButton onClick={() => setActiveStep("vehicle")}>
          <Box
            p="6px"
            style={{
              backgroundColor: "var(--mantine-color-orange-6)",
              borderRadius: "var(--mantine-radius-sm)",
            }}
          >
            <Flex justify="center" align="center" gap="xs">
              <ThemeIcon radius="xl" size="xs" color="white">
                <IconCheck
                  strokeWidth={4}
                  size={12}
                  style={{
                    color: "var(--mantine-color-orange-6)",
                  }}
                />
              </ThemeIcon>
              <Text align="center" size="lg" fw={600} c="white">
                {t("microsite:at_dealer_button")}
              </Text>
            </Flex>
            <Text align="center" c="white">
              {t("microsite:validate_my_odometer")}
            </Text>
          </Box>
        </UnstyledButton>
        <UnstyledButton
          onClick={() => {
            window.open(
              "https://h-dletsride.com/offsite-registration",
              "_blank"
            );
            sendActionEvents({
              action_id: actionIds.RC_VISIT_DEALERSHIP_LATER,
              events: entityInfo?.paid_media_settings?.events || [],
            });
          }}
        >
          <Box
            p="6px"
            style={{
              backgroundColor: "var(--mantine-color-dark-7)",
              borderRadius: "var(--mantine-radius-sm)",
            }}
          >
            <Flex justify="center" align="center" gap="xs">
              <ThemeIcon radius="xl" size="xs" color="white"></ThemeIcon>
              <Text align="center" size="lg" fw={600} c="white">
                {t("microsite:not_at_dealer_button")}
              </Text>
            </Flex>
            <Text align="center" c="white">
              {t("microsite:im_registered_ill_validate_later")}
            </Text>
          </Box>
        </UnstyledButton>
      </Stack>
      <Text align="center" c="dimmed" mt="xl">
        {t("microsite:fully_registered_text")}
      </Text>
    </div>
  );

  return (
    <div>
      <RideChallengeHeader />
      <Stack mt="xl" gap="md">
        <Text align="center" c="white" fw={600} size="xl">
          Hey, you're registered, but you're not competing until you visit a
          dealership and get a validated vin and odometer reading
        </Text>
        <Text align="center" c="white" fw={600} size="xl">
          Are you at a dealership?
        </Text>
        <Button size="lg" onClick={() => setActiveStep("vehicle")}>
          Yes, I'm here
        </Button>
        <Button
          size="lg"
          variant="light"
          onClick={() => {
            window.open(
              "https://h-dletsride.com/offsite-registration",
              "_blank"
            );
          }}
        >
          No, I'll finish later
        </Button>
      </Stack>
    </div>
  );
}
